import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    { path: "/", redirect: "/login" },
    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Login.vue")
    },
    {
      path: "/my-dashboard",
      name: "my-dashboard",
      component: () =>
        import(/* webpackChunkName: "my-dashboard" */ "./views/MyDashboard.vue")
    },
    {
      path: "/company-dashboard",
      name: "company-dashboard",
      component: () =>
        import(
          /* webpackChunkName: "company-dashboard" */ "./views/CompanyDashboard.vue"
        )
    }
  ],
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active"
});
